import React, {Component} from 'react';
import {AMOUNT_RULE_TYPES} from 'utils/constants';
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';
import ChangeAmountLimit from '../popup/ChangeAmountLimit.PopUp.component';
import {Switch} from "components/common/Switch.component";
import Checkbox from "components/common/checkbox.component";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownSelectTypes } from "types/gaiaComponents/dropdownButton.types";

export class AmountCondition extends Component {

    constructor(props) {
        super(props);
        this.showChangeAmountLimit = this.showChangeAmountLimit.bind(this);
        this.changeLimit = this.changeLimit.bind(this);
        this.changeLimitHigh = this.changeLimitHigh.bind(this);
        this.changeLimitLow = this.changeLimitLow.bind(this);
        this.changeLimitType = this.changeLimitType.bind(this);
        this.toggleAmountCondition = this.toggleAmountCondition.bind(this);
        this.toggleAmountConditionCheckbox = this.toggleAmountConditionCheckbox.bind(this);
        this.showChangeAmountLimit = this.showChangeAmountLimit.bind(this);

        this.state = {
            showAmountLimitsDialog: false
        }
    }

    changeLimit(value) {
        let newAmount = Object.assign({}, this.props.condition);
        newAmount.limit = value;
        this.props.changeAmountCondition(newAmount);
    };


    changeLimitHigh(value) {
        let newAmount = Object.assign({}, this.props.condition);
        newAmount.limitHigh = value;
        let isComplete = newAmount.limitLow !== null && newAmount.limitLow !== undefined;
        this.props.changeAmountCondition(newAmount, isComplete);
    };


    changeLimitLow(value) {
        let newAmount = Object.assign({}, this.props.condition);
        newAmount.limitLow = value;
        let isComplete = newAmount.limitHigh !== null && newAmount.limitHigh !== undefined;
        this.props.changeAmountCondition(newAmount, isComplete);
    };


    changeLimitType(value) {
        let newAmount = Object.assign({}, this.props.condition);
        newAmount.xtype = value;
        newAmount.conditionType = value;
        if (value === AMOUNT_RULE_TYPES["Visma.Approval.Rules.AmountConditionBetween"].xType) {
            if (newAmount.limit)
                delete newAmount.limit;
            newAmount.limitHigh = undefined;
            newAmount.limitLow = undefined;
        } else {
            if (newAmount.limitHigh)
                delete newAmount.limitHigh;
            if (newAmount.limitLow)
                delete newAmount.limitLow;
            newAmount.limit = undefined;
        }

        this.props.changeAmountCondition(newAmount, false);
    };


    toggleAmountCondition(event) {
        if (event.target.checked) {
            this.changeLimitType("Visma.Approval.Rules.AmountConditionBelow");
        } else {
            this.props.changeAmountCondition(null);
        }

    };

    toggleAmountConditionCheckbox(event) {
        if (event.currentTarget?.querySelector("input").checked) {
            this.changeLimitType("Visma.Approval.Rules.AmountConditionBelow");
        } else {
            this.props.changeAmountCondition(null);
        }
    }

    showChangeAmountLimit() {
        this.setState({showAmountLimitsDialog: true});
    }

    render() {
        let props = this.props;

        let hasAmountConditionSet = props.condition && AMOUNT_RULE_TYPES[props.condition.conditionType] !== undefined;
        let limit, lowerLimit, upperLimit, isSimpleLimit;

        if (hasAmountConditionSet) {
            isSimpleLimit = props.condition.conditionType !== AMOUNT_RULE_TYPES["Visma.Approval.Rules.AmountConditionBetween"].xType;
            if (isSimpleLimit) {
                limit = props.amountLimits.find(amount => {
                    return amount.limitId === props.condition.limit
                });
            } else {
                lowerLimit = props.amountLimits.find(amount => {
                    return amount.limitId === props.condition.limitLow
                });
                upperLimit = props.amountLimits.find(amount => {
                    return amount.limitId === props.condition.limitHigh
                });
            }
        }

        // Create menu items for amount type dropdown
        const amountTypeItems = Object.keys(AMOUNT_RULE_TYPES).map((key) => {
            return {
                key: key,
                text: props.translate("workflowDetails." + AMOUNT_RULE_TYPES[key].translationKey),
                onClick: () => this.changeLimitType(key),
                disabled: false,
                selected: props.condition && props.condition.conditionType === key
            };
        });

        // Create menu items for amount limits
        const createAmountLimitItems = (onClick, selectedLimitId) => {
            return props.amountLimits ? props.amountLimits.map(amount => {
                return {
                    key: amount.limitId,
                    text: amount.name,
                    onClick: () => onClick(amount.limitId),
                    disabled: false,
                    selected: selectedLimitId === amount.limitId
                };
            }) : [];
        };

        const limitItems = createAmountLimitItems(this.changeLimit, props.condition?.limit);
        const lowerLimitItems = createAmountLimitItems(this.changeLimitLow, props.condition?.limitLow);
        const upperLimitItems = createAmountLimitItems(this.changeLimitHigh, props.condition?.limitHigh);

        return (
            <div className="my-4">
                {this.state.showAmountLimitsDialog &&
                    <ChangeAmountLimit
                        translate={props.translate}
                        amountLimits={props.amountLimits}
                        closeCallback={() => {
                            this.setState({showAmountLimitsDialog: false})
                        }}
                    />
                }

                {this.props.isStepLevel ?
                    <div className="active-slider">
                        <Switch isChecked={hasAmountConditionSet}
                                onChange={this.toggleAmountCondition}
                                isDisabled={false}
                                label={props.translate("workflowDetails.stepCondition")}
                        />
                    </div>

                    : <Checkbox
                        inputId={`amount-condition-checkbox-step${props.stepNumber}-rule${props.idRule || props.ruleNumber}`}
                        onChange={this.toggleAmountConditionCheckbox}
                        isChecked={hasAmountConditionSet}
                        ariaLabel={props.translate("workflowDetails.amountCondition")}
                        label={props.translate("workflowDetails.amountCondition")}
                    />
                }

                {hasAmountConditionSet &&
                    <div className="d-flex flex-row align-items-center mt-3 gap-8">
                        <div className="d-inline-flex">
                            <DropdownSelect
                                id="amount_type"
                                type={DropdownSelectTypes.VALUE}
                                value={props.translate("workflowDetails." + AMOUNT_RULE_TYPES[props.condition.conditionType].translationKey)}
                                items={amountTypeItems}
                                isEmpty={amountTypeItems.length === 0}
                            />
                        </div>
                        {isSimpleLimit ?
                            <div className="d-inline-flex">
                                <DropdownSelect
                                    id="amount_limit"
                                    type={DropdownSelectTypes.VALUE}
                                    value={limit ? limit.name : ''}
                                    items={limitItems}
                                    isEmpty={limitItems.length === 0}
                                />
                            </div> :
                            (<span>
                                    <div className="d-inline-flex">
                                        <DropdownSelect
                                            id="amount_limit_low"
                                            type={DropdownSelectTypes.VALUE}
                                            value={lowerLimit ? lowerLimit.name : ''}
                                            items={lowerLimitItems}
                                            isEmpty={lowerLimitItems.length === 0}
                                        />
                                    </div>
                                    <span className="d-inline-flex mx-3"> {props.translate("generic.and")} </span>
                                    <div className="d-inline-flex">
                                        <DropdownSelect
                                            id="amount_limit_high"
                                            type={DropdownSelectTypes.VALUE}
                                            value={upperLimit ? upperLimit.name : ''}
                                            items={upperLimitItems}
                                            isEmpty={upperLimitItems.length === 0}
                                        />
                                    </div>
                                </span>
                            )
                        }

                        <a className="ms-3"
                           onClick={this.showChangeAmountLimit}
                        >
                            {props.translate("workflowDetails.changeLimits")}
                        </a>
                    </div>
                }
            </div>

        )
    }
}

const mapStateToProps = function (store) {
    return {
        amountLimits: reduxSelectors.getWorkflowsAmountLimits(store)
    };
};

const connected = connect(mapStateToProps, {})(AmountCondition);
export default connected;
